module.exports = __webpack_public_path__ + "img/blh_common.b2313452.png";